<template lang="html">
  <div id="index-scroll-content" :style='{"transform": "translateY("+distance+"px)"}'>
    <refresh :length="distance"></refresh>
    <swiperIndex></swiperIndex>
    <activity></activity>
    <indexEntry></indexEntry>
    <headLine></headLine>
    <taoqianggou></taoqianggou>
  </div>
</template>

<script>
import refresh from './refresh'
import swiperIndex from './swiperIndex'
import activity from './activity'
import indexEntry from './indexEntry'
import headLine from './headLine'
import taoqianggou from './taoqianggou'

export default {
  components: {
    refresh,
    swiperIndex,
    activity,
    indexEntry,
    headLine,
    taoqianggou
  },
  mounted () {
    let $el = document.getElementById("index-scroll-content"),
      $vue = this;
    $el.addEventListener("touchstart",(function(e){
      this.className = "";
      $vue.touchStart = e.touches[0].pageY + this.scrollTop;
    }))
    $el.addEventListener("touchmove",(function(e){
      if(this.scrollTop>0) return false;
      let distance = (e.touches[0].pageY - $vue.touchStart)*30;
      $vue.distance = Math.sqrt(distance<0?0:distance).toFixed(0);
    }))
    $el.addEventListener("touchend",(function(e){
      $vue.distance = 0;
      this.className = "up";
    }))
    $el.addEventListener("touchcancel",(function(e){
      $vue.distance = 0;
      this.className = "up";
    }))
  },
  data: () => {
    return {
      touchStart: 0,
      distance: 0
    }
  }
}
</script>

<style lang="scss">
  #index-scroll-content{
    flex: 1;
    position: relative;
    overflow: scroll;
    background: #fff;
  }
  #index-scroll-content.up{
    transition: all .2s ease-out;
  }
</style>



// WEBPACK FOOTER //
// scrollContent.vue?04adaf9c